module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel-heading top-margin"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Transaction " + _vm._s(_vm.transactionId))])]), _vm._v(" "), _c('div', {
    staticClass: "row notification"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row transation-info"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row first-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.maturityDate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteId))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row first-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.getPaymentType))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.amount)))])])])])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Transaction date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Note number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Payment type:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "line-separator top-margin"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fb5f872","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpcomingTransactions/UpcomingTransactionsData.vue
// module id = 2167
// module chunks = 1